module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Today, " + _vm._s(_vm.today) + ":")]), _c('p', [_vm._v("Donald Trump is on 🔥 with an approval rating of "), _c('span', {
    staticClass: "approve"
  }, [_vm._v(_vm._s(Number(_vm.dataToday.approve_estimate).toFixed(1)) + "%")]), _c('span', [_vm._v(" and disapproval of ")]), _c('span', {
    staticClass: "disapprove"
  }, [_vm._v(_vm._s(Number(_vm.dataToday.disapprove_estimate).toFixed(1)) + "%")])]), _c('p', [(_vm.busy) ? _c('icon', {
    attrs: {
      "name": "refresh",
      "scale": "3",
      "spin": "spin"
    }
  }) : _vm._e()], 1), (_vm.dataToday.approve_estimate < 60) ? _c('p', [_vm._v("A great big"), _c('span', {
    staticStyle: {
      "color": "#F00",
      "text-transform": "uppercase"
    }
  }, [_vm._v(" Fail!!")])]) : _vm._e(), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://projects.fivethirtyeight.com/trump-approval-ratings/"
    }
  }, [_vm._v("Trump Approvial Ratings ")]), _c('sup', [_vm._v("@538")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e2e2994"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Approval.vue
// module id = 1080
// module chunks = 1